import { Form, Formik } from 'formik';
import React, { FC, ReactElement, useEffect, useState } from 'react';
import { REPORTS_FILTER_TIME } from '../../../constants/element-type';
import { TranslationKeys } from '../../../contexts/TranslationKeys';
import { useLocale } from '../../../contexts/localeContext';
import { useFilter } from '../../../contexts/table/FilterContext';
import { useTable } from '../../../contexts/table/TableContext';
import WizardSideBarStep from '../../../models/WizardSideBarStep';
import { getFormattedTime, getTime, setTime } from '../../../services/utilities/dateFormatting';
import Wizard from '../../wizard/wizard';
import Summary from './summary-step';
import TimeStep from './time-step';

interface TimeFilterWizardProps {
    defaultContent: ReactElement[];
    defaultSteps: WizardSideBarStep[];
    onClose: () => void;
    filterModalTrigger: string;
}

const TimeFilterWizard: FC<TimeFilterWizardProps> = ({defaultContent, defaultSteps, onClose, filterModalTrigger}) => {
    const { translate } = useLocale();
    const filterContext = useFilter();
    const tableContext = useTable();
    const [currentItem, setCurrentItem] = useState({time: new Date()});
    const [step, setStep] = useState<number>(1);
    const steps: WizardSideBarStep[] = [
        ...defaultSteps,
        {
            title: translate.byKey(TranslationKeys.time),
            description: "",
            substeps: []
        },
        {
            title: translate.byKey(TranslationKeys.summary),
            description: "",
            substeps: []
        }
    ]

    useEffect(() => {
        const filter = filterContext.filters.find(filter => filter.key === "time");
        if (filter && filter.selected.length > 0) {

            setCurrentItem({ time: setTime(filter.selected[0].value)});
        }
    }, [])

    const onNext = (event: any) => {
        setStep(step + 1);
    }

    const onBack = (event: any) => {
        setStep(step - 1);
    }

    const content: ReactElement[] = [
        ...defaultContent,
        <TimeStep
            key={"wizard-1"}
            onBack={onBack}
            onNext={onNext}
            filterModalTrigger={filterModalTrigger} />,
        <Summary
            key={"wizard-2"}
            onBack={onBack} />
    ];

    const handleSubmit = (values: any) => {
        const columnId: any = tableContext.tableDescriptor.find(column => column.accessor === 'time')?.id;
        const time: string = getFormattedTime(getTime(values.time));
        filterContext.updateFilters(columnId, time, time, undefined, REPORTS_FILTER_TIME);
        onClose();
    }

    return <Formik
        enableReinitialize={true}
        initialValues={currentItem}
        onSubmit={handleSubmit}>
        <Form>
            <Wizard name={translate.byKey(TranslationKeys.dataFilters)}
                step={step}
                onClose={onClose}
                sidebarSteps={steps}>
                {content}
            </Wizard>
        </Form>
    </Formik>
}

export default TimeFilterWizard;